import { isUserRoleApprover, isUserLogirest, isUserSupply } from './roles'

export const needsApprovalCart = ({ user, center } = {}) =>
  !!(center?.requiresApproval && !isUserRoleApprover(user) && !isUserLogirest(user) && !isUserSupply(user))
